export default __webpack_public_path__ + "static/media/eyeClosed.dd2c44b7.svg";